var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMartialArts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Martial-Arts-Karate--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Martial Arts Karate Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.85 4a1.52 1.52 0 0 0 -2.09 0.39l-5 7a0.27 0.27 0 0 1 -0.16 0.1 0.25 0.25 0 0 1 -0.19 0L10.74 8.7a0.25 0.25 0 0 1 -0.06 -0.33l0.32 -0.61a1.08 1.08 0 0 1 1 -0.51 4.06 4.06 0 0 0 4 -4.05v-1a1.5 1.5 0 0 0 -3 0v1a1 1 0 0 1 -1.05 1 4.07 4.07 0 0 0 -3.48 2L5.8 10.69a4.49 4.49 0 0 0 1.37 6.06l0.62 0.41a1.5 1.5 0 1 0 1.66 -2.49l-0.62 -0.42a1.5 1.5 0 0 1 -0.46 -2l0.5 -0.84a0.26 0.26 0 0 1 0.13 -0.14 0.24 0.24 0 0 1 0.2 0l4.16 3.12a0.25 0.25 0 0 1 0.1 0.2v7.12a1.5 1.5 0 0 0 3 0v-7.4a0.25 0.25 0 0 1 0.05 -0.15l5.73 -8.06a1.51 1.51 0 0 0 -0.39 -2.1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.75a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMartialArts);
export default ForwardRef;